<template>
  <div>
    <b-modal
        :title="$t(add ? 'Add new a meeting schedule' : 'Edit a meeting schedule')"
        v-model="show"
        dialog-class="trans-modal bg-app"
        :hide-footer="true"
        size="xl"
        no-close-on-backdrop lazy>
      <ValidationObserver ref="form" tag="form" @submit.prevent="save()" style="max-width: 550px; margin: 0 auto">
        <b-row>
          <div class="col-md-12">
            <b-form-group>
              <ValidationProvider rules="required" v-slot="{ errors }">
                <b-input-group class="input-group-trans">
                  <b-form-input v-model="formData.name" :placeholder="$t('Meeting schedule name')" :disabled="loading"/>
                  <b-input-group-append>
                    <b-input-group-text>
                      <img src="images/ico-start-meeting.png"/>
                    </b-input-group-text>
                  </b-input-group-append>
                </b-input-group>
                <div class="validate-error">{{ errors[0] }}</div>
              </ValidationProvider>
            </b-form-group>
          </div>
        </b-row>
        <b-row>
          <div class="col-md-12">
            <label>{{$t('Meeting time')}}</label>
          </div>
          <div class="col-md-6">
            <b-form-group>
              <ValidationProvider rules="required" v-slot="{ errors }">
                <b-form-timepicker v-model="formData.fromTime" class="input-trans" :hide-header="false" :placeholder="$t('Start time')" :disabled="loading" locale="vi" />
                <div class="validate-error">{{ errors[0] }}</div>
              </ValidationProvider>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group>
              <ValidationProvider rules="required" v-slot="{ errors }">
                <b-form-timepicker v-model="formData.toTime" class="input-trans"  :hide-header="false" :placeholder="$t('End time')" :disabled="loading" locale="vi"/>
                <div class="validate-error">{{ errors[0] }}</div>
              </ValidationProvider>
            </b-form-group>
          </div>
        </b-row>
        <div v-if="meetingType == 3">
          <b-row>
            <div class="col-md-6">
              <b-form-group>
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <b-form-datepicker v-model="formData.fromDate" class="input-trans" :hide-header="false" :placeholder="$t('Start date')" :disabled="loading" :locale="locale" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" />
                  <div class="validate-error">{{ errors[0] }}</div>
                </ValidationProvider>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group>
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <b-form-datepicker v-model="formData.toDate" class="input-trans"  :hide-header="false" :placeholder="$t('End date')" :disabled="loading" :locale="locale" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"/>
                  <div class="validate-error">{{ errors[0] }}</div>
                </ValidationProvider>
              </b-form-group>
            </div>
          </b-row>
          <b-row>
            <div class="col-md-12">
              <b-form-group class="mb-3">
                <div>{{$t("Meeting days")}}</div>
                <b-checkbox-group v-model="formData.dayOfWeeks">
                  <b-checkbox value="/0/">{{$t("Sunday")}}</b-checkbox>
                  <b-checkbox value="/1/">{{$t("Monday")}}</b-checkbox>
                  <b-checkbox value="/2/">{{$t("Tuesday")}}</b-checkbox>
                  <b-checkbox value="/3/">{{$t("Wednesday")}}</b-checkbox>
                  <b-checkbox value="/4/">{{$t("Thursday")}}</b-checkbox>
                  <b-checkbox value="/5/">{{$t("Friday")}}</b-checkbox>
                  <b-checkbox value="/6/">{{$t("Saturday")}}</b-checkbox>
                </b-checkbox-group>
              </b-form-group>
            </div>
          </b-row>
        </div>
        <div v-else>
          <b-row>
            <div class="col-md-12">
              <b-form-group>
                <ValidationProvider rules="required" v-slot="{ errors }">
                  <b-form-datepicker v-model="formData.date" class="input-trans" :hide-header="false" :placeholder="$t('Meeting date')" :disabled="loading" :locale="locale" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" />
                  <div class="validate-error">{{ errors[0] }}</div>
                </ValidationProvider>
              </b-form-group>
            </div>
          </b-row>
        </div>

        <b-row>
          <div class="col-md-12">
            <b-form-group class="mb-1">
              <b-checkbox v-model="formData.isOverrideMeetingCogs">{{$t('Override meeting settings')}}</b-checkbox>
            </b-form-group>
          </div>
        </b-row>
        <div v-if="formData.isOverrideMeetingCogs">
          <b-row>
            <div class="col-md-12">
              <b-form-group class="mb-1">
                <b-checkbox v-model="formData.isTurnOffParticipantVideos">{{$t('Turn off video of participants')}}</b-checkbox>
              </b-form-group>
              <b-form-group class="mb-4">
                <b-checkbox v-model="formData.isTurnOffDinhDong">{{$t('Turn off ding dong sound')}}</b-checkbox>
              </b-form-group>
              <b-form-group class="mb-3">
                <div>{{$t("What kind of authentication do you want with your users?")}}</div>
                <b-radio-group v-model="formData.idAuthen">
                  <b-form-radio value="1">{{$t("Free join")}}</b-form-radio>
                  <b-form-radio value="2">{{$t("Free join with account")}}</b-form-radio>
                  <b-form-radio value="3">{{$t("Registered join")}}</b-form-radio>
                </b-radio-group>
              </b-form-group>
            </div>
          </b-row>
        </div>
        <b-row>
          <div class="col-md-12">
            <b-form-group>
              <b-checkbox v-model="formData.isBlocked">{{$t('Block this schedule')}}</b-checkbox>
            </b-form-group>
          </div>
        </b-row>


        <b-form-group class="mb-0">
          <b-button type="submit" pill size="lg" class="btn-block btn-trans-primary" :disabled="loading">
            {{
              $t(add ? "Save" : "Save changes")
            }}
          </b-button>
        </b-form-group>
      </ValidationObserver>
    </b-modal>
    <PanelLoading :show="loading" message="Saving data"/>
  </div>
</template>

<script>
import meetingService from "../services/meeting_service";
import dialogHelper from "../helpers/dialog_helper";

export default {
  name: "EditScheduleModal",
  data: function () {
    return {
      show: false,
      loading: false,
      add: false,
      meetingType: 1,
      locale: "en",
      formData: {
        id: "",
        name: "",
        fromTime: "",
        toTime: "",
        dayOfWeeks: [],
        date: "",
        fromDate: "",
        toDate: "",
        isOverrideMeetingCogs: false,
        isTurnOffParticipantVideos: false,
        isTurnOffHostVideo: false,
        isTurnOffDinhDong: false,
        isBlocked: false,
        idAuthen: 1
      }
    }
  },
  methods: {
    async edit2(id) {
      this.add = false;
      this.meetingType = 2;
      this.loading = true;
      let response = await meetingService.editMeetingSchedule2(id);
      this.loading = false;
      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        dialogHelper.alert(response, "error");
        return;
      }

      let data = JSON.parse(response.substr(3));
      this.formData = {
        id: data.ScheduleID,
        name: data.Name,
        fromTime: data.FromTime,
        toTime: data.ToTime,
        dayOfWeeks: [],
        date: data.Date,
        fromDate: "",
        toDate: "",
        isOverrideMeetingCogs: data.IsOverrideMeetCongs,
        isTurnOffParticipantVideos: !data.IsTurnOnParticipantVideos,
        isTurnOffHostVideo: !data.IsTurnOnHostVideo,
        isTurnOffDinhDong: !data.IsTurnOnDingDong,
        isBlocked: data.IsBlocked,
        idAuthen: data.IDAuth
      }
      this.show = true;
    },
    async edit3(id) {
      this.add = false;
      this.meetingType = 3;
      this.loading = true;
      let response = await meetingService.editMeetingSchedule3(id);
      this.loading = false;
      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        dialogHelper.alert(response, "error");
        return;
      }

      let data = JSON.parse(response.substr(3));
      this.formData = {
        id: data.ScheduleID,
        name: data.Name,
        fromTime: data.FromTime,
        toTime: data.ToTime,
        dayOfWeeks: data.DaysOfWeek.replace(/\//g, '').split('').map(x => `/${x}/`),
        date: "",
        fromDate: data.FromDate,
        toDate: data.ToDate,
        isOverrideMeetingCogs: data.IsOverrideMeetCongs,
        isTurnOffParticipantVideos: !data.IsTurnOnParticipantVideos,
        isTurnOffHostVideo: !data.IsTurnOnHostVideo,
        isTurnOffDinhDong: !data.IsTurnOnDingDong,
        isBlocked: data.IsBlocked,
        idAuthen: data.IDAuth
      }
      this.show = true;
    },
    addSchedule(meetingType) {
      this.add = true;
      this.meetingType = meetingType;

      this.formData = {
        id: null,
        name: "",
        fromTime: "00:00",
        toTime: "00:00",
        dayOfWeeks: [],
        date: "",
        fromDate: "",
        toDate: "",
        isOverrideMeetingCogs: false,
        isTurnOffParticipantVideos: false,
        isTurnOffHostVideo: false,
        isTurnOffDinhDong: false,
        isBlocked: false,
        idAuthen: 1
      }
      this.show = true;
    },
    async save() {
      if ((await this.$refs.form.validate()) != true)
        return;

      if (this.loading)
        return;

      this.loading = true;
      let response;
      if (this.add) {
        response = this.meetingType == 2 ? await meetingService.addMeetingSchedule2(this.formData) : await meetingService.addMeetingSchedule3(this.formData);
      }
      else {
        response = this.meetingType == 2 ? await meetingService.saveEditMeetingSchedule2(this.formData) : await meetingService.saveEditMeetingSchedule3(this.formData);
      }

      this.loading = false;
      if (!response)
        return;

      if (!response.startsWith("OK|")) {
        dialogHelper.alert(response, "error");
        return;
      }

      let data = JSON.parse(response.substr(3));
      dialogHelper.alert(data.Msg, "success");
      this.show = false;
      this.$emit("saveChanges", data.Schedules);
    }
  },
  created() {
    this.locale = this.$store.getters.languageCode;
  }
}
</script>

<style scoped>

</style>